var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "video",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.23,
    height: 42.43,
    viewBox: "0 0 62.23 42.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M12.486,13.657H6.829A2.829,2.829,0,1,1,6.829,8h5.657a2.829,2.829,0,1,1,0,5.657Z",
    transform: "translate(4.486 1.9)",
    fill: "#3e3e3e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M60.6,8.372a4.987,4.987,0,0,0-5.111.246l-9.23,6.152V11.625A7.134,7.134,0,0,0,39.133,4.5H8.125A7.134,7.134,0,0,0,1,11.625V39.8A7.134,7.134,0,0,0,8.125,46.93H39.133A7.134,7.134,0,0,0,46.258,39.8V36.659l9.23,6.152a4.981,4.981,0,0,0,7.742-4.144v-25.9A4.984,4.984,0,0,0,60.6,8.372ZM40.6,39.8a1.468,1.468,0,0,1-1.468,1.468H8.125A1.468,1.468,0,0,1,6.657,39.8V11.625a1.468,1.468,0,0,1,1.468-1.468H39.133A1.468,1.468,0,0,1,40.6,11.625Zm16.972-2.4L46.258,29.859V21.571l11.315-7.544Z",
    transform: "translate(-1 -4.5)",
    fill: "#3e3e3e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.7c74142fbe39faa2c131b9a61f6fec94.svg";
export { ForwardRef as ReactComponent };